import type { RouteProps } from 'react-router'
import { Route } from 'react-router-dom'
import { useLocaleStrippedLocation } from './useLocaleStrippedLocation'

export default function LocaleAwareRoute(props: RouteProps) {
  const matchLocation = useLocaleStrippedLocation()
  return <Route {...props} location={matchLocation} />
}
